<div class="streaming-dictation-container">
  <!-- Recording Button -->
  <button
    mat-raised-button
    [color]="isRecording ? 'warn' : 'primary'"
    [disabled]="!isReady && !isRecording"
    (click)="toggleRecording()"
    class="record-button"
    [attr.aria-label]="getButtonText()">
    <mat-icon>{{ getButtonIcon() }}</mat-icon>
    <span>{{ getButtonText() }}</span>
  </button>
  
  <!-- Connection Status Indicator -->
  <div class="status-indicator" *ngIf="connectionStatus !== 'connected'">
    <mat-icon [class]="'status-' + connectionStatus">
      {{ connectionStatus === 'connecting' ? 'sync' : connectionStatus === 'error' ? 'error' : 'signal_wifi_off' }}
    </mat-icon>
    <span class="status-text">
      {{ connectionStatus === 'connecting' ? 'Connecting...' : connectionStatus === 'error' ? 'Connection Error' : 'Disconnected' }}
    </span>
  </div>
  
  <!-- LLM Processing Indicator -->
  <div class="llm-indicator" *ngIf="isProcessingLLM">
    <mat-spinner diameter="20"></mat-spinner>
    <span>Processing with LLM...</span>
  </div>
  
  <!-- Error Message -->
  <div class="error-message" *ngIf="errorMessage">
    <mat-icon>error</mat-icon>
    <span>{{ errorMessage }}</span>
    <button mat-icon-button (click)="errorMessage = null" class="dismiss-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <!-- Warning Message -->
  <div class="warning-message" *ngIf="warningMessage">
    <mat-icon>warning</mat-icon>
    <span>{{ warningMessage }}</span>
  </div>
  
  <!-- Transcript Display (optional, for preview) -->
  <div class="transcript-preview" *ngIf="currentTranscript && displayMode === 'streaming'">
    <div class="transcript-label">Live Transcript:</div>
    <div class="transcript-text">{{ currentTranscript }}</div>
  </div>
  
  <!-- Display Mode Indicator -->
  <div class="display-mode-indicator" *ngIf="displayMode === 'blind'">
    <mat-icon>visibility_off</mat-icon>
    <span>Blind mode: Transcript will appear when final</span>
  </div>
</div>

